exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect__placeholder{color:#495057}.multiselect__option--highlight,.multiselect__option--highlight:after{background:#00a5e3}.multiselect__tags{background-color:#fafaf7;height:calc(1.5em + .75rem + 2px);padding:5px 40px 0 8px;font-size:16px}.md-ripple{padding:0!important}.table.vgt-table{font-size:20px}.form-control{border:1px solid #ced4da!important;background-image:none;border-radius:5px!important}.custom-select{background-color:#fafaf7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b03873ca","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/js/pages/admin/projects.vue
// module id = 286
// module chunks = 0